import PropTypes from "prop-types";

const propTypes = {
  user: PropTypes.shape({
    I_UZ: PropTypes.number,
    Token: PropTypes.string.isRequired,
    Roles: PropTypes.array,
    Version: PropTypes.string,
    Uzivatel: PropTypes.shape({
      I_UZ: PropTypes.number,
      N_UZ: PropTypes.string,
      HESLO: PropTypes.string,
      POZN: PropTypes.string,
      ZRUS: PropTypes.bool,
      L_OVERENY: PropTypes.bool,
      MOBIL: PropTypes.string,
      L_AKTIV: PropTypes.bool,
      I_GOOGLE: PropTypes.string,
      L_GOOGLE: PropTypes.bool,
      L_ADMIN: PropTypes.bool,
      I_ORGANS: PropTypes.arrayOf(PropTypes.number),
    }),
  }),
};

export default propTypes;
